<template>
  <v-container>
    <QuickNavigation :fileData="fileData" :routeHistory="$route" />
    <div>
      <v-row>
        <v-col cols="12">
          <div class="d-flex">
            <v-btn color="secondary" elevation="0" @click="undo"> UNDO </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" elevation="0" @click="save"> Save </v-btn>
          </div>
        </v-col>

        <v-col cols="12" md="5">
          <v-sheet height="50" color="transparent">
            <div>Credit Report Liabilities</div>
            <v-checkbox
              v-model="hideItemsWithZeroBalance"
              label="Hide items with zero balance"
              hide-details="auto"
              dense
            />
          </v-sheet>
          <v-sheet outlined>
            <v-simple-table dense height="600">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      <v-checkbox
                        dense
                        hide-details="auto"
                        @change="selectAll"
                      />
                    </th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Unpaid Bal</th>
                    <th class="text-left">Payment</th>
                    <th class="text-left">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="liability in creditReportLiabilities"
                    :key="`liability-` + liability.creditLiabilityID"
                  >
                    <template
                      v-if="
                        !(hideItemsWithZeroBalance && liability.unpaidBal == 0)
                      "
                    >
                      <td>
                        <v-checkbox
                          :id="`credit-${liability.creditLiabilityID}`"
                          v-model="liability.selected"
                          dense
                          hide-details="auto"
                        />
                      </td>
                      <td :title="liability.name">
                        <div class="overflow-ellipsis" style="width: 70px">
                          {{ liability.name }}
                        </div>
                      </td>
                      <td>{{ liability.unpaidBal | currency("$", 2, 1) }}</td>
                      <td>{{ liability.moPayment | currency("$", 2, 1) }}</td>
                      <td>
                        {{
                          $store.state.mstCodeEnums[
                            `debtType${liability.debtType}`
                          ]
                        }}
                      </td>
                    </template>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-sheet>
        </v-col>
        <v-col class="text-center" cols="12" md="1">
          <v-container fill-height>
            <v-row justify="center" align="center">
              <v-col cols="12">
                <v-btn elevation="0" class="my-1" @click="move"> >> </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="12" md="6">
          <v-sheet height="50" color="transparent">
            <div>1003 Liabilities</div>
            <div>section</div>
          </v-sheet>
          <v-sheet outlined>
            <v-simple-table dense height="600">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Unpaid Bal</th>
                    <th class="text-left">Payment</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Ommit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(debt, index) in originLiabilities"
                    :key="
                      debt.debtId + '-' + debt.creditLiabilityID + '-' + index
                    "
                  >
                    <td :title="debt.name">
                      <div class="overflow-ellipsis" style="width: 70px">
                        {{ debt.name }}
                      </div>
                    </td>
                    <td>{{ debt.unpaidBal | currency("$", 2, 1) }}</td>
                    <td>{{ debt.moPayment | currency("$", 2, 1) }}</td>
                    <td>
                      {{
                        $store.state.mstCodeEnums[`debtType${debt.debtType}`]
                      }}
                    </td>
                    <td>
                      <v-checkbox
                        v-model="debt.omitted"
                        dense
                        hide-details="auto"
                        color="error"
                      />
                      <!-- <v-dialog v-model="debt.dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="secondary"
                          >
                            <v-icon> mdi-pencil </v-icon>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="grey lighten-2">
                            Edit Liability
                          </v-card-title>

                          <div>
                            <v-row no-gutters>
                              <v-col cols="12" md="6">
                                <div>Name: {{ debt.name }}</div>
                                <div>Attn: {{ debt.attn }}</div>
                                <div>Street: {{ debt.street }}</div>
                                <div>
                                  City, State, Zip: {{ debt.city }},
                                  {{ debt.state }} {{ debt.zip }}
                                </div>
                                <div>Account No: {{ debt.accountNo }}</div>
                                <div>Fax: {{ debt.fax }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-checkbox
                                  label="Resubordinated"
                                  v-model="debt.resubordinated"
                                  dense
                                  hide-details="auto"
                                />
                                <v-checkbox
                                  label="Omitted"
                                  v-model="debt.omitted"
                                  dense
                                  hide-details="auto"
                                />
                                <v-checkbox
                                  label="Listed on Credit Report"
                                  v-model="debt.listedOnCreditReport"
                                  dense
                                  hide-details="auto"
                                />
                              </v-col>
                            </v-row>
                          </div>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              text
                              @click="debt.dialog = false"
                            >
                              Close
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog> -->
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
    <LoanDetailSubMenu />
  </v-container>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";
import { convert } from "@/mixins";

export default {
  name: "Contact",
  components: {
    QuickNavigation,
    LoanDetailSubMenu,
  },
  async mounted() {
    const fileData = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.$route.query.loanNumber,
        option: "AllWithOutEmbeddedDocs",
      })
      .then((resp) => resp.data)
      .catch(() => null);

    this.fileData = fileData;
    this.selectedBorrower = fileData.applications[0].borrower;

    const originLiabilities = await this.$store
      .dispatch("debtApi/get", this.selectedBorrower.borrowerId)
      .then((resp) => resp.data)
      .catch(() => null);

    const embeddedDocs = await this.$store
      .dispatch("embeddeddoc/get", { fileDataId: this.fileData.fileDataId })
      .then((resp) => resp.data)
      .catch(() => null);

    const temp = embeddedDocs.filter((x) => x.embeddedDocType == 284)[0];

    const debts = await this.$store
      .dispatch("debtApi/parseCreditReport", {
        fileDataId: temp.fileDataId,
        embeddedDocId: temp.embeddedDocId,
      })
      .then((resp) => resp.data)
      .catch(() => null);

    this.originLiabilities = originLiabilities;
    this.backUpLiabilities = JSON.parse(JSON.stringify(originLiabilities));

    this.creditReportLiabilities = debts;

    this.backUpCreditReportLiabilities = JSON.parse(
      JSON.stringify(this.creditReportLiabilities)
    );
  },
  data() {
    return {
      hideItemsWithZeroBalance: false,
      fileData: null,
      backUpLiabilities: null,
      backUpCreditReportLiabilities: null,
      originLiabilities: null,
      creditReportLiabilities: null,
      selectedBorrower: null,
    };
  },
  methods: {
    undo() {
      this.creditReportLiabilities = JSON.parse(
        JSON.stringify(this.backUpCreditReportLiabilities)
      );
      this.originLiabilities = JSON.parse(
        JSON.stringify(this.backUpLiabilities)
      );
    },
    move() {
      this.creditReportLiabilities.forEach((element) => {
        if (element.selected) {
          this.originLiabilities.push(element);
        }
      });
      this.creditReportLiabilities = this.creditReportLiabilities.filter(
        (element) => {
          return !element.selected;
        }
      );
    },
    selectAll(val) {
      for (let i = 0; i < this.creditReportLiabilities.length; i++) {
        this.creditReportLiabilities[i].selected = val;
      }
    },
    async save() {
      this.$store.commit("setGlobalLoading", true);
      try {
        const updatedDebts = this.originLiabilities.filter(
          (element) => element.debtId > 0
        );
        const createdDebts = this.originLiabilities.filter(
          (element) => element.debtId === 0
        );

        await this.$store.dispatch("debtApi/update", {
          borrowerId: updatedDebts[0].borrowerId,
          debts: updatedDebts,
        });
        await this.$store.dispatch("debtApi/create", {
          borrowerId: updatedDebts[0].borrowerId,
          debts: createdDebts,
        });

        this.$store.commit(
          "statusDialog/showSuccessDialog",
          "Debt saved successfully."
        );
      } catch (e) {
        this.$store.commit(
          "statusDialog/showErrorDialog",
          "Error saving debt."
        );
      }

      this.$store.commit("setGlobalLoading", false);
    },
  },
  mixins: [convert],
};
</script>
